/* eslint-disable */
import React from 'react'
import axios from 'axios'
import { toArray } from 'lodash'
import { Grid, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap'
import Card from 'components/Card/Card.jsx'
import { connect } from 'react-redux'
import Modal from 'components/Modal/Modal.jsx'
import Button from 'elements/CustomButton/CustomButton.jsx'
import '../../css/table.css'
import ReactTable from 'react-table'
import { orderBy, isEmpty, map } from 'lodash'
import { db, keygen, storage } from '../../services/firebase'
import { compress, readImage } from '../../services/compressor'
import SweetAlert from 'react-bootstrap-sweetalert'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import SweetSpinner from 'components/SweetSpinner/SweetSpinner.jsx'
import CorporateForm from 'forms/CorporateForm.jsx'
import Gallery from 'components/Gallery/Gallery.jsx'
import {
    setName, setActive, setCoverImage, setCoverImageName,
    addGalleryImage, removeGalleryImage, resetProduct, cloneBeforeUpdate
} from '../../ducks/Corporate'

class Corporate extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            alert: null,
            products: [],
            loading: false,
            isModalVisible: false,
            target: null
        }

        this.user = props.user
        this.resetForm = props.resetForm
        this.submitForm = props.submitForm
        this.notify = props.notify
    }

    componentDidMount() {
        this._fetchCorporate()
    }

    render() {
        const { alert, products, loading } = this.state

        return (
            <div className='main-content'>
                {alert}
                {this._formModal()}
                <Card
                    content={
                        <Grid fluid>
                            <Row>
                                <Col md={12}>
                                    <Button
                                        bsStyle='default'
                                        wd
                                        className='pull-right'
                                        style={{ marginBottom: 10 }}
                                        onClick={() => {
                                            this.props.resetForm('CorporateForm')
                                            this.setState({ isModalVisible: true })
                                        }}
                                    >
                                        Adicionar Produto
                            </Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <ReactTable
                                        columns={[
                                            { Header: 'Nome', accessor: 'name' },
                                            { Header: 'Ativo', accessor: 'activeText' },
                                            {
                                                Header: 'Ações', accessor: '',
                                                Cell: ({ value }) => (this._renderTableActions(value))
                                            }
                                        ]}
                                        data={orderBy(this._prepareTableData(products), ['name'], ['asc'])}
                                        onFetchData={this._fetchCorporate}
                                        loading={loading}
                                        defaultPageSize={10}
                                        className='-striped -highlight'
                                        previousText='Anterior'
                                        nextText='Próximo'
                                        loadingText='Carregando'
                                        noDataText='Nenhum produto encontrado'
                                        pageText='Página'
                                        ofText='de'
                                        rowsText='Registros'
                                    />
                                </Col>
                            </Row>
                        </Grid>
                    }
                />
            </div>
        )
    }

    _prepareTableData = products => {
        const output = []
        map(products, product => output.push({ ...product, activeText: product.active ? 'Sim' : 'Não' }))

        return output
    }

    _renderTableActions = value => (
        <div style={{ textAlign: 'center' }}>
            <OverlayTrigger
                placement='top'
                overlay={(<Tooltip id={`edit_${value.id}`}>Editar</Tooltip>)}
            >
                <a
                    className='btn btn-simple btn-default btn-icon'
                    onClick={() => this._populateRedux(value.id)}
                >
                    <FontAwesomeIcon className='text-dark' icon='edit' />
                </a>
            </OverlayTrigger>

            <OverlayTrigger
                placement='top'
                overlay={(<Tooltip id={`delete_${value.id}`}>Remover</Tooltip>)}
            >
                <a
                    className='btn btn-simple btn-default btn-icon'
                    onClick={() => this.removeCorporateAlert(value.id)}
                >
                    <FontAwesomeIcon className='text-dark' icon='trash' />
                </a>
            </OverlayTrigger>
        </div>
    )

    _populateRedux = id => {
        this.waitAlert('Preparando dados', true)

        db.collection('corporate').doc(id).get()
            .then(productSnap => {
                this.props.setName(productSnap.data().name)
                this.props.setActive(productSnap.data().active)

                if (productSnap.data().coverImageURL) {
                    let img = new Image()
                    img.src = productSnap.data().coverImageURL
                    this.props.setCoverImage(img)
                    this.props.setCoverImageName(productSnap.data().coverImageName)
                }

                db.collection('corporate').doc(id).collection('gallery').get()
                    .then(gallerySnap => {
                        if (!gallerySnap.empty) {
                            gallerySnap.forEach(galleryImage => {
                                let image = new Image()
                                image.src = galleryImage.data().downloadURL
                                this.props.addGalleryImage({
                                    image,
                                    id: galleryImage.id,
                                    imageName: galleryImage.data().name
                                })
                            })

                            this.props.cloneBeforeUpdate()
                            this.hideAlert()
                            this.setState({ isModalVisible: true, target: id })
                        } else {
                            this.props.cloneBeforeUpdate()
                            this.hideAlert()
                            this.setState({ isModalVisible: true, target: id })
                        }

                    })
                    .catch(e => {
                        console.log(e)
                        this.hideAlert()
                        this.props.notify('Erro ao buscar imagens.', 'error')
                    })

            })
            .catch(e => {
                console.log(e)
                this.hideAlert()
                this.props.notify('Erro ao buscar produto.', 'error')
            })
    }

    _formModal = () => {
        const { isModalVisible, target } = this.state
        const { setCoverImage, addGalleryImage, removeGalleryImage, notify, corporate } = this.props
        return (
            <Modal
                overflowY
                size='modal__big'
                title={target ? 'Editar Produto' : 'Adicionar Produto'}
                isOpen={isModalVisible}

                content={
                    <div>
                        <CorporateForm
                            initialValues={corporate}
                            onSubmit={values => this._handleSubmit(values)}
                        />
                        <Gallery
                            product={corporate}
                            notify={notify}
                            setCoverImage={setCoverImage}
                            addGalleryImage={addGalleryImage}
                            removeGalleryImage={removeGalleryImage}
                        />
                        <Row style={{ marginBottom: 15 }}>
                            <Col md={6} sm={12} xs={12}>
                                <Button
                                    style={{ width: '100%', marginTop: 25 }}
                                    bsStyle='danger'
                                    type='button'
                                    onClick={this._handleCancel}
                                    wd
                                >
                                    Cancelar
                         </Button>
                            </Col>
                            <Col md={6} sm={12} xs={12}>
                                <Button
                                    style={{ width: '100%', marginTop: 25 }}
                                    bsStyle='default'
                                    type='submit'
                                    fill
                                    onClick={() => this.props.submitForm('CorporateForm')}
                                >
                                    Salvar
                         </Button>
                            </Col>
                        </Row>
                    </div>
                }
            />
        )
    }

    _handleSubmit = async values => {
        const { target } = this.state
        const { corporate, notify, beforeUpdate } = this.props

        this.setState({ isModalVisible: false })

        if (!target) {
            this.waitAlert('Adicionando Produto', true)
            const productKey = keygen()
            const ImagesPromiseStack = []

            let productToSave = {
                name: values.name,
                active: values.active.value,
            }

            if (corporate.coverImage) {
                const uploadedCover = await this._handleImage(corporate.coverImage, productKey, 'corporate')
                productToSave.coverImageURL = uploadedCover.downloadURL
                productToSave.coverImageName = uploadedCover.metadata.name
            }

            if (!isEmpty(corporate.gallery)) {
                map(corporate.gallery, async galleryImage => {
                    let uploadedGalleryImage = await this._handleImage(galleryImage.image, galleryImage.id, 'corporate')

                    ImagesPromiseStack.push(
                        db
                            .collection('corporate')
                            .doc(productKey)
                            .collection('gallery')
                            .doc(galleryImage.id)
                            .set({
                                downloadURL: uploadedGalleryImage.downloadURL,
                                name: uploadedGalleryImage.metadata.name
                            })
                    )
                })
            }

            Promise.all(ImagesPromiseStack)
                .then(() => {
                    axios.post('https://us-central1-enele-e47f5.cloudfunctions.net/syncAlgoliaAddCorporate_HTTPS', {
                        id: productKey, data: productToSave
                    })
                        .then(() => {
                            notify('Produto adicionado.', 'success')
                            this.hideAlert()
                            this.props.resetProduct()
                        })
                        .catch(e => {
                            console.log(e)
                            this.hideAlert()
                            notify('Erro ao sincronizar os dados.', 'error')
                        })
                })
                .catch(e => {
                    console.log(e)
                    this.hideAlert()
                    this.setState({ isModalVisible: true })
                    notify('Erro ao salvar as imagens da galeria.', 'error')
                })
        }

        if (target) {
            this.waitAlert('Atualizando produto, aguarde', true)

            let productToSave = {
                name: values.name,
                active: typeof (values.active) === 'object' ? values.active.value : values.active
            }

            if (corporate.coverImage !== beforeUpdate.coverImage) { //remove old image
                storage.ref().child(`corporate/${beforeUpdate.coverImageName}`).getDownloadURL()
                    .then(async url => {
                        await storage.ref().child(`corporate/${beforeUpdate.coverImageName}`).delete()
                        if (corporate.coverImage) {
                            const updatedCover = await this._handleImage(corporate.coverImage, target, 'corporate')
                            productToSave.coverImageURL = updatedCover.downloadURL
                            productToSave.coverImageName = updatedCover.metadata.name
                        }

                        this._updateUsingAxios(target, productToSave)
                    })
                    .catch(async e => {
                        if (corporate.coverImage) {
                            const updatedCover = await this._handleImage(corporate.coverImage, target, 'corporate')
                            productToSave.coverImageURL = updatedCover.downloadURL
                            productToSave.coverImageName = updatedCover.metadata.name
                        }

                        this._updateUsingAxios(target, productToSave)
                    })
            } else {
                this._updateUsingAxios(target, productToSave)
            }
        }
    }

    _updateUsingAxios = (id, data) => {
        const { notify } = this.props
        axios.post('https://us-central1-enele-e47f5.cloudfunctions.net/syncAlgoliaUpdateCorporate_HTTPS', { id, data })
            .then(() => {
                this._updateGallery(id)
                    .then(() => {
                        notify('Produto atualizado.', 'success')
                        this.hideAlert()
                        this.props.resetProduct()
                        this.setState({ target: null })
                    })
                    .catch(e => {
                        console.log(e)
                        this.setState({ isModalVisible: true })
                        notify('Erro ao atualizar a galeria.', 'error')
                    })
            })
            .catch(e => {
                console.log(e)
                this.hideAlert()
                this.setState({ isModalVisible: true })
                notify('Erro ao sincronizar os dados.', 'error')
            })
    }

    _updateGallery = id => {
        const PromiseStack = []
        const { beforeUpdate, corporate, notify } = this.props

        return new Promise((resolve, reject) => {
            if (!isEmpty(beforeUpdate.gallery) && isEmpty(corporate.gallery)) {
                console.log('Remover todas as imagens da galeria')

                map(beforeUpdate.gallery, imageToRemove => {

                    PromiseStack.push(
                        db.collection('corporate').doc(id).collection('gallery').doc(imageToRemove.id).delete()
                            .catch(e => console.log(e)),
                        storage.ref().child(`corporate/${imageToRemove.imageName}`).delete()
                            .catch(e => console.log(e))
                    )
                })

                Promise.all(PromiseStack)
                    .then(() => notify('Galeria removida.', 'success'))
                    .catch(e => {
                        console.log(e)
                        notify('Erro ao modificar a galeria de imagens.', 'error')
                    })

            } else if (isEmpty(beforeUpdate.gallery) && !isEmpty(corporate.gallery)) {
                console.log('Adicionar todas as imagens da galeria')
                map(corporate.gallery, async imageToAdd => {
                    let newImage = await this._handleImage(imageToAdd.image, imageToAdd.id, 'corporate')

                    PromiseStack.push(
                        db.collection('corporate').doc(id).collection('gallery').doc(imageToAdd.id)
                            .set({
                                downloadURL: newImage.downloadURL,
                                name: newImage.metadata.name
                            })
                            .catch(e => console.log(e))
                    )
                })

                return Promise.all(PromiseStack)
                    .then(() => notify('Imagens adicionadas a galeria.', 'success'))
                    .catch(e => {
                        console.log(e)
                        notify('Erro ao adicionar imagens a galeria.', 'error')
                    })

            } else {
                const arrayBefore = toArray(beforeUpdate.gallery)
                const arrayCorporate = toArray(corporate.gallery)

                //Adds new items to the gallery
                map(arrayCorporate, async currentGalleryItem => {
                    if (!arrayBefore.find(x => x.id === currentGalleryItem.id)) {
                        let newImage = await this._handleImage(currentGalleryItem.image, currentGalleryItem.id, 'corporate')
                        PromiseStack.push(
                            db.collection('corporate').doc(id).collection('gallery').doc(currentGalleryItem.id)
                                .set({
                                    downloadURL: newImage.downloadURL,
                                    name: newImage.metadata.name
                                })
                                .catch(e => console.log(e))
                        )
                    }
                })

                //Remove missing items in current gallery
                map(arrayBefore, async oldGalleryItem => {
                    if (!arrayCorporate.find(x => x.id === oldGalleryItem.id)) {
                        PromiseStack.push(
                            db.collection('corporate').doc(id).collection('gallery').doc(oldGalleryItem.id).delete()
                                .catch(e => console.log(e)),
                            storage.ref().child(`corporate/${oldGalleryItem.imageName}`).delete()
                                .catch(e => console.log(e))
                        )
                    }
                })

                //Resolve the Promise stack
                return Promise.all(PromiseStack)
                    .then(() => resolve('Galeria atualizada.'))
                    .catch(e => {
                        console.log(e)
                        reject('Erro ao atualizar a galeria.')
                    })
            }
        })
    }

    _handleCancel = _ => {
        this.setState({ isModalVisible: false, target: null })
        this.props.resetForm('CorporateForm')
        this.props.resetProduct()
    }

    async _handleImage(image, name, pathToUpload) {
        const receivedImage = await image
        const compressedImage = await compress(receivedImage.src)
        const extension = this._handleExtension(compressedImage.type)

        if (extension) {
            const uploadedImage = await storage.ref().child(`${pathToUpload}/${name}.${extension}`).put(compressedImage)
            return uploadedImage
        } else {
            this.props.notify('Erro ao comprimir imagem.', 'error')
        }
    }

    _handleExtension(mimeType) {
        let ext = mimeType.split('/')
        switch (ext[1]) {
            case 'jpeg':
            case 'jpg':
                return 'jpg'
            case 'png':
                return 'png'
            default:
                return null
        }
    }

    _fetchCorporate = () => {
        this.setState({ loading: true })
        db.collection('corporate').onSnapshot(snapshot =>
            !snapshot.empty
                ? this._passCorporateToState(snapshot)
                : this.setState({ loading: false })
        )
    }

    _passCorporateToState = snapshot => {
        const products = []
        snapshot.forEach(s => products.push({ ...s.data(), id: s.id }))
        return this.setState({ loading: false, products })
    }

    _removeCorporate = id => {
        this.waitAlert('Removendo Produto', false)

        db.collection('corporate').doc(id).delete()
            .then(() => {
                axios.post('https://us-central1-enele-e47f5.cloudfunctions.net/syncAlgoliaDeleteCorporate_HTTPS', { id })
                    .then(() => {
                        this.props.notify('Produto removido.', 'success')
                        this.props.notify('Caso ele não desapareça da lista, atualize a página.', 'info')
                        this.hideAlert()
                    })
                    .catch(e => {
                        this.props.notify('Erro ao sincronizar dados.', 'error')
                        this.hideAlert()
                    })
            })
            .catch(e => {
                this.props.notify('Erro ao remover produto.', 'error')
                this.hideAlert()
            })
    }

    //SweetAlerts
    hideAlert = () => this.setState({ alert: null })

    waitAlert = (title, showSpinner) => {
        this.setState({
            alert: (
                <SweetAlert
                    style={{ display: 'block' }}
                    title={title}
                    onConfirm={() => null}
                    showConfirm={false}
                >
                    {showSpinner ? (<SweetSpinner />) : null}
                </SweetAlert>
            )
        })
    }

    removeCorporateAlert = id => {
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{ display: "block" }}
                    title="Tem certeza?"
                    onConfirm={() => this._removeCorporate(id)
                    }
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="default"
                    cancelBtnBsStyle="warning"
                    confirmBtnText="Sim"
                    cancelBtnText="Não"
                    showCancel
                />
            )
        });
    }

}

const mapStateToProps = state => ({
    corporate: state.corporate.product,
    beforeUpdate: state.corporate.beforeUpdate
})

export default connect(mapStateToProps, {
    setName, setActive, setCoverImage, setCoverImageName,
    addGalleryImage, removeGalleryImage, resetProduct, cloneBeforeUpdate
})(Corporate)



// WEBPACK FOOTER //
// ./src/views/Corporate/Corporate.jsx